
/**
 * 응답 데이터
 * @nullable
 */
export type GetApiV1RefundsEligibilityOrderId200AllOfData = { [key: string]: unknown } | null;
